<template lang="html">

    <div class="wrapper margin-menu -area-personal column-center">

        <div class="contenedor-formulario">

            <h1 class="title-intro">Crear suscripción</h1>

            <div class="payment-container">

                <h4>Cuanto quieres donar</h4>

                <div class="contenedor-input -radios row-center">
                    <div class="radio">
                        <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="20"
                            id="amount-20">
                        <label for="amount-20"><strong>20</strong> Euros</label>
                    </div>
                    <div class="radio">
                        <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="25"
                            id="amount-25">
                        <label for="amount-25"><strong>25</strong> Euros</label>
                    </div>
                    <div class="radio">
                        <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="50"
                            id="amount-50">
                        <label for="amount-50"><strong>50</strong> Euros</label>
                    </div>
                    <div class="radio">
                        <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="100"
                            id="amount-100">
                        <label for="amount-100"><strong>100</strong> Euros</label>
                    </div>

                    <div class="contenedor-input">
                        <label for="otheramount">Indicar otra cantidad</label>
                        <input @change="setOtherAmount" type="text" name="amount" id="otheramount"
                            v-model="data.otheramount">
                    </div>

                    <span v-if="erroramount" class="error">Por favor, selecciona un importe para donar</span>
                </div>

                <h4>¿Cada cuanto tiempo?</h4>

                <div class="contenedor-input row-center">

                    <div class="radio-el">
                        <input type="radio" name="time" v-model="data.time" :value="'1'" id="time-tarjeta"
                            v-validate="'required'">
                        <label for="time-tarjeta">Mensual</label>
                    </div>

                    <div class="radio-el">
                        <input type="radio" name="time" v-model="data.time" :value="'2'" id="time-transferencia"
                            v-validate="'required'">
                        <label for="time-transferencia">Anual</label>
                    </div>
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('time')
                        }}</span>

                </div>

                <div class="contenedor-tarjeta" v-show="cards.length == 0">
                    <h4>Introduce tu tarjeta</h4>
                    <div class="contenedor-input">
                        <label for="card-element">Número de tarjeta</label>
                        <div id="card-element"></div>
                    </div>
                    <p class="card-error" v-if="!!errormessage">{{errormessage}}</p>
                </div>

                <!-- <div class="contenedor-input -checkbox">
                    <input type="checkbox" class="input-check" v-validate="'required'" id="politica-contacto"
                        name="politica" :placeholder="$t('formulario.telefono')" />
                    <label for="politica-contacto">He leído y acepto la <router-link
                            :to="$t('enlaces.politica_privacidad')">
                            política de privacidad</router-link></label>
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica')
                        }}</span>
                </div> -->


                <div class="contenedor-boton row-center">
                    <button @click="validateBeforeSubmit" class="btn red" :loading="loading">Hacer
                        donación</button>
                </div>

            </div>



        </div>

    </div>

</template>


<script>

    import { mapActions } from 'vuex';

    import router from '@/router';

    export default {
        name: 'crear-suscripcion',
        mounted() {
            this.includeStripe('js.stripe.com/v3/', function () {
                this.configureStripe();
            }.bind(this));


            setTimeout(() => {

                //TODO IF LOGGED

                this.requestcards().then(r => {
                    this.cards = r;
                });

                this.requestuser().then(r => {
                    this.user = r;
                });

            }, 200);

        },
        data() {
            return {
                data: {
                    amount: '',
                    otheramount: '',
                    time: 0
                },
                loading: false,
                erroramount: false,
                clicked: false,
                card: '',
                cards: '',
                stripeAPIToken: 'pk_live_51Iw1iqIjMOewFaa7cMvytnq4Q0pEXIjOHKPCZzHIL5LdlFWLbqL0nED6zCmYuJN5i4kf4qiUgALNWoHtwaZ5kHbe00iZ1sb2Xv',
                stripe: '',
                errormessage: '',
                user : ''
            }
        },
        methods: {
            ...mapActions(['createSubscription', 'requestcards', 'makeIntentSave', 'saveCard','requestuser']),
            includeStripe(URL, callback) {
                let documentTag = document, tag = 'script',
                    object = documentTag.createElement(tag),
                    scriptTag = documentTag.getElementsByTagName(tag)[0];
                object.src = '//' + URL;
                if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
                scriptTag.parentNode.insertBefore(object, scriptTag);
            },
            configureStripe() {

                this.stripe = Stripe(this.stripeAPIToken);
                this.elements = this.stripe.elements();
                this.card = this.elements.create(
                    'card',
                    {
                        style: {
                            base: {
                                fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                                fontSize: '16px',
                                fontSmoothing: 'antialiased',
                                ':-webkit-autofill': {
                                    color: '#fce883',
                                },
                                '::placeholder': {
                                    color: '#64686b',
                                },
                            },
                        },
                    }
                );
                this.card.mount('#card-element');


                this.card.on('change', event => {
                    if (event.complete) {
                        this.cardvalid = true;
                        this.errormessage = '';
                    } else if (event.error) {
                        this.errormessage = event.error.message;
                    } else if (!!!event.error) {
                        this.errormessage = '';
                    }
                });
            },
            validateBeforeSubmit() {

                this.erroramount = (!!!this.data.amount);

                this.$validator.validateAll().then(canSend => {

                    if (canSend && !this.erroramount) {

                        if (this.cards.length != 0) {
                            this.loading = true;
                            this.requestsuscripcion();
                        } else {
                            if (this.cardvalid) {
                                this.loading = true;
                                this.makeIntentSave().then(r => {
                                    this.client_secret = r;
                                    this.validateCard(r);
                                });
                            }
                        }

                    }
                });
            },
            requestsuscripcion() {
                this.createSubscription(this.data).then(r => {
                    if (r) {
                        router.push({ name: 'areainterna' });
                        this.loading = false;
                    }
                });
            },
            validateCard(client_secret) {
                this.stripe.confirmCardSetup(client_secret, {
                    payment_method: {
                        card: this.card,
                        billing_details: { name: this.user.name }
                    }
                }).then(result => {
                    this.saveCard(result.setupIntent).then(r => {
                        if (r) {
                            this.requestsuscripcion();
                        }
                    });

                }).catch(e => {
                    console.log(e);
                })
            },
            setOtherAmount() {
                if (!!this.data.otheramount) {
                    this.data.amount = this.data.otheramount.replace(/\,/g, '.');
                }
            },
            eraseOtherAmount() {
                if (!!this.data.amount) {
                    this.data.otheramount = '';
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/views/crear-subscripcion.vue